import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../../components/header';
import Sidebar from '../../components/sidebar';
import Footer from '../../components/footer';
import { Paginator } from 'primereact/paginator';
import Loader from '../../components/loader';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Invoice from './downloadInvoice';
import ReactDOM from 'react-dom/client';

function formatNumber(number, length) {
    return String(number).padStart(length, '0');
}

function App() {
    const [orderData, setorderData] = useState([]);
    const userId = sessionStorage.getItem("TRCUserId");
    const [loader, setLoader] = useState(false);
    const dates = sessionStorage.getItem("invDate");
    const [first, setFirst] = useState(0); 
    const [rows, setRows] = useState(8); 
    const [date, setDate] = useState(dates);
    const [dealerSearch, setDealerSearch] = useState('');
    const [whatsappNum, setWhatsAppNum] = useState(false);
    const [newWhatsappNum, setNewWhatsAppNum] = useState(0);
    const [selectedInvoices, setSelectedInvoices] = useState([]);
    const [showActionButtons, setShowActionButtons] = useState(false);
    const [selectedSections, setSelectedSections] = useState(['printableArea1', 'printableArea2', 'printableArea3', 'printableArea4']);
    const [showPhoneDialog, setShowPhoneDialog] = useState(false);
    const [dealersWithoutPhone, setDealersWithoutPhone] = useState([]);
    const [phoneNumbers, setPhoneNumbers] = useState({});
 
    const [isRouteDropdownOpen, setIsRouteDropdownOpen] = useState(false);
    const [selectedRoutes, setSelectedRoutes] = useState(['all']);
    const [selectedVnum, setSelectedVnum] = useState('all');

    const formatDate = (date) => {
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${newDate.getFullYear()}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${String(newDate.getDate()).padStart(2, '0')}`;
        return formattedDate;
    };

    const formatViewDate = (date) => {
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${String(newDate.getDate()).padStart(2, '0')}-${String(newDate.getMonth() + 1).padStart(2, '0')}-${newDate.getFullYear()}`;
        return formattedDate;
    };


    const toggleRouteDropdown = () => {
        setIsRouteDropdownOpen(!isRouteDropdownOpen);
    };

    const handleRouteSelection = (route) => {
        if (route === 'all') {
            if (selectedRoutes.includes('all')) {
                setSelectedRoutes([]);
            } else {
                setSelectedRoutes(['all']);
            }
        } else {
            if (selectedRoutes.includes(route)) {
                const updatedRoutes = selectedRoutes.filter(r => r !== route);
                if (updatedRoutes.length === 0) {
                    setSelectedRoutes(['all']);
                } else {
                    setSelectedRoutes(updatedRoutes.filter(r => r !== 'all'));
                }
            } else {
                const updatedRoutes = [...selectedRoutes.filter(r => r !== 'all'), route];
                setSelectedRoutes(updatedRoutes);
            }
        }
    };

    const isRouteSelected = (route) => {
        return selectedRoutes.includes('all') || selectedRoutes.includes(route);
    };

    // Vnum filter handler
    const handleVnumChange = (e) => {
        setSelectedVnum(e.target.value);
    };

    const handleCheckboxChange = (orderId) => {
        setSelectedInvoices(prevSelected => {
            if (prevSelected.includes(orderId)) {
                return prevSelected.filter(id => id !== orderId);
            } else {
                return [...prevSelected, orderId];
            }
        });
    };

    const handleSelectAllChange = (e) => {
        if (e.target.checked) {
            setSelectedInvoices(filteredOrders.map(order => order.orderId));
        } else {
            setSelectedInvoices([]);
        }
    };

    useEffect(() => {
        setShowActionButtons(selectedInvoices.length > 0);
    }, [selectedInvoices]);

    const changeDate = async (e) => {
        setLoader(true);
        const date = e.target.value;
        sessionStorage.setItem("invDate", date);
        sessionStorage.setItem("invPage", 0);
        setFirst(0);
        setSelectedInvoices([]);
        const newDate = new Date(date);
        const formattedDate = `${newDate.getFullYear()}/${String(newDate.getMonth() + 1).padStart(2, '0')}/${String(newDate.getDate()).padStart(2, '0')}`;
        setDate(formattedDate);

        try {
            const response = await axios.post('https://api.trucoo.in/invoice/invoice/', {date: formattedDate}, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
            if(response.data.status === 'success'){
                setorderData(response.data.data);
                setDate(response.data.date);
            }else{
                setorderData([]);
                setDate(formatDate(response.data.date));
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
        setLoader(false);
    };

    const getOrders = async (date) => {
        setLoader(true);
        const newDate = new Date(date);
        const formattedDate = `${newDate.getFullYear()}/${String(newDate.getMonth() + 1).padStart(2, '0')}/${String(newDate.getDate()).padStart(2, '0')}`;
        setDate(formattedDate);
        try {
            const response = await axios.post('https://api.trucoo.in/invoice/invoice/', {date: formattedDate}, {
                headers: {
                    'Content-Type': 'application/json',
                    'X-API-KEY': 'erpTrucoo'
                }
            });
            if(response.data.status === 'success'){
                setorderData(response.data.data);
                setDate(response.data.date);
            }else{
                setorderData([]);
                setDate(formatDate(response.data.date));
            }
        } catch (error) {
            console.error("Error:", error.response || error.message);
        }
        setLoader(false);
    };

    function getFiscalYearLabel(date = new Date()) {
        const year = date.getFullYear();
        const month = date.getMonth(); 
        if (month < 3) {
          return `${(year-1).toString().slice(-2)}-${year.toString().slice(-2)}`;
        } else {
          return `${year.toString().slice(-2)}-${(year + 1).toString().slice(-2)}`;
        }
    };

    useEffect(() => {
        const page = parseFloat(sessionStorage.getItem("invPage") || 0);
        setFirst(page);
        if(dates && dates !== null){
            getOrders(dates);
        }else{
            const today = new Date();
            const formattedDate = today.toLocaleDateString();
            getOrders(formattedDate);
        }
    },[]);

    useEffect(() => {
        const intervalId = setInterval(() => {
            const page = parseFloat(sessionStorage.getItem("invPage") || 0);
            setFirst(page);
            if(dates && dates !== null){
                getOrders(dates);
            }else{
                const today = new Date();
                const formattedDate = today.toLocaleDateString();
                getOrders(formattedDate);
            }
        }, 300000);
    
        return () => clearInterval(intervalId);
    }, []);

    // Get unique routes and vnums from order data
    const uniqueRoutes = [...new Set(orderData.map(order => order.dealerData?.routes).filter(Boolean))];
    const uniqueVnums = [...new Set(orderData.map(order => order.vNum).filter(Boolean))];

    const filteredOrders = orderData.filter(order => {
        const dealerMatches = !dealerSearch || 
            (order.dealerData?.dealer?.toLowerCase().includes(dealerSearch.toLowerCase()));
        
        const routeMatches = selectedRoutes.includes('all') || 
            (order.dealerData?.routes && selectedRoutes.includes(order.dealerData.routes));
        
        const vnumMatches = selectedVnum === 'all' || 
            (order.vNum && order.vNum === selectedVnum);
        
        return dealerMatches && routeMatches && vnumMatches;
    });

    const fiscalYear = getFiscalYearLabel(new Date());

    const checkDealersPhoneNumbers = () => {
        const dealersMissingPhone = [];
        const phoneMap = {};
        
        selectedInvoices.forEach(orderId => {
            const order = orderData.find(o => o.orderId === orderId);
            if (order) {
                const phone = order.dealerData.phone;
                if (!phone || phone.trim() === '') {
                    dealersMissingPhone.push({
                        orderId,
                        dealerName: order.dealerData.dealer
                    });
                } else {
                    phoneMap[orderId] = phone;
                }
            }
        });
        
        setDealersWithoutPhone(dealersMissingPhone);
        setPhoneNumbers(phoneMap);
        
        return dealersMissingPhone.length === 0;
    };

    const handlePhoneNumberChange = (orderId, value) => {
        setPhoneNumbers(prev => ({
            ...prev,
            [orderId]: value
        }));
    };

    const sendAllInvoices = async () => {
        setShowPhoneDialog(false);
        setLoader(true);
        
        try {
            for (const orderId of selectedInvoices) {
                const order = orderData.find(o => o.orderId === orderId);
                if (!order) continue;

                const phoneNumber = phoneNumbers[orderId] || order.dealerData.phone;
                if (!phoneNumber) continue;

                const tempContainer = document.createElement('div');
                document.body.appendChild(tempContainer);
                const root = ReactDOM.createRoot(tempContainer);

                try {
                    await new Promise(resolve => {
                        root.render(<Invoice getData={order} />);
                        setTimeout(resolve, 200); 
                    });

                    let sections = selectedSections.map(id => document.getElementById(id)).filter(Boolean);
                    sections.forEach(el => el.classList.remove("hide"));

                    const pdf = new jsPDF("p", "mm", "a4");
                        
                    for (let i = 0; i < sections.length; i++) {
                        const element = sections[i];
                        const canvas = await html2canvas(element, { scale: 2 }); 
                        const imgData = canvas.toDataURL("image/jpeg");
                        const pdfWidth = pdf.internal.pageSize.getWidth();
                        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
                        
                        if (i > 0) pdf.addPage();
                        pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
                    }

                    const filename = `${order.dealerData.dealer}-TRC/${order.invoiceId}/${fiscalYear}/${formatViewDate(order.date)}`;
                    const pdfBlob = pdf.output("blob");
                    
                    const formData = new FormData();
                    formData.append("file", pdfBlob, `${orderId}.pdf`);
                    formData.append("pdfName", filename);
                    formData.append("orderId", orderId);
                    formData.append("name", order.dealerData.dealer);
                    formData.append("date", order.date);
                    formData.append("phone", phoneNumber);

                    await axios.post(
                        'https://api.trucoo.in/invoice/upload-pdf/', 
                        formData, 
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data',
                                'X-API-KEY': 'erpTrucoo'
                            }
                        }
                    );
                } finally {
                    root.unmount();
                    document.body.removeChild(tempContainer);
                }
            }

            alert(`${selectedInvoices.length} invoice(s) sent successfully!`);
            setSelectedInvoices([]);
        } catch (error) {
            console.error("Error sending invoices:", error);
            alert('Some invoices failed to send.');
        } finally {
            setLoader(false);
        }
    };

    const handleSendClick = () => {
        const allHavePhone = checkDealersPhoneNumbers();
        if (allHavePhone) {
            sendAllInvoices();
        } else {
            setShowPhoneDialog(true);
        }
    };

    const downloadCombinedPDF = async (option) => {
        if (option === 'whatsapp') {
            handleSendClick();
            return;
        }
        
        setLoader(true);
        setWhatsAppNum(false);

        const tempContainer = document.createElement('div');
        document.body.appendChild(tempContainer);
        const root = ReactDOM.createRoot(tempContainer);

        try {
            const shouldCombine = option === 'print' || option === 'print all';
            const combinedPdf = shouldCombine ? new jsPDF("p", "mm", "a4") : null;
            let firstInvoice = true;

            for (const orderId of selectedInvoices) {
                const order = orderData.find(o => o.orderId === orderId);
                if (!order) continue;
                setNewWhatsAppNum(order?.dealerData?.phone);

                await new Promise(resolve => {
                    root.render(<Invoice getData={order} />);
                    setTimeout(resolve, 200);
                });

                let sections = [];

                if (order?.eWayNum?.length > 0) {
                    sections = [
                        document.getElementById("printableArea1"),
                        document.getElementById("printableArea2"),
                        // document.getElementById("printableArea3"),
                        // document.getElementById("printableArea4")
                    ];
                } else {
                    sections = [
                        document.getElementById("printableArea1"),
                        // document.getElementById("printableArea3"),
                       // document.getElementById("printableArea4")
                    ];
                }
                sections.forEach(el => el.classList.remove("hide"));

                if (shouldCombine) {
                    for (let i = 0; i < sections.length; i++) {
                        const element = sections[i];
                        const canvas = await html2canvas(element, { scale: 5 });
                        const imgData = canvas.toDataURL("image/jpeg");
                    
                        const pdfWidth = combinedPdf.internal.pageSize.getWidth();
                        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
                    
                        if (!firstInvoice || i > 0) {
                            combinedPdf.addPage();
                        }
                        combinedPdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
                    }
                    firstInvoice = false;
                } else {
                    const pdf = new jsPDF("p", "mm", "a4");

                    for (let i = 0; i < sections.length; i++) {
                        const element = sections[i];
                        const canvas = await html2canvas(element, { scale: 5 });
                        const imgData = canvas.toDataURL("image/jpeg");
                    
                        const pdfWidth = pdf.internal.pageSize.getWidth();
                        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
                    
                        if (i > 0) pdf.addPage();
                        pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, pdfHeight);
                    }

                    const filename = `${order?.dealerData?.dealer}-TRC/${order?.invoiceId}/${fiscalYear}/${formatViewDate(order?.date)}`;

                    switch (option) {
                        case 'download':
                            pdf.save(filename);
                            break;
                        case 'view':
                        case 'printview':
                            if (option === 'printview') {
                                pdf.autoPrint();
                            }
                            window.open(pdf.output("bloburl"), '_blank');
                            break;
                    }
                }

                sections.forEach(el => el.classList.add("hide"));
            }

            if (shouldCombine && combinedPdf) {
                combinedPdf.autoPrint();
                window.open(combinedPdf.output("bloburl"), '_blank');
            }

        } catch (error) {
            console.error("Error in downloadCombinedPDF:", error);
            alert('An error occurred while processing invoices');
        } finally {
            root.unmount();
            document.body.removeChild(tempContainer);
            setLoader(false);
        }
    };

    let totalCrates = 0;
    let totalQty = 0;
    let totalLKg = 0;
    let totalAmount = 0;

    console.log("Filtered Orders:", filteredOrders);

    return (
        <>
            {loader && <Loader />}
            <Header />
            <Sidebar />

            <div className="content-wrapper">
                <div className="container-full">
                    <section className="content">
                        <div className="box">
                            <div className="box-header with-border">
                                <h4 className="box-title">All Invoices</h4>
                               

                                <div style={{ display: 'flex', gap: '10px', alignItems: 'center', marginTop: '10px', flexWrap: 'wrap' }}>
                                    <input 
                                        type="date" 
                                        className="form-control" 
                                        value={formatDate(date)} 
                                        onChange={(e) => changeDate(e)} 
                                        style={{ width: '200px' }} 
                                    />
                                    
                                    <input 
                                        type="text" 
                                        placeholder="Search Dealer" 
                                        className="form-control" 
                                        value={dealerSearch} 
                                        onChange={(e) => setDealerSearch(e.target.value)} 
                                        style={{ width: '200px' }}
                                    />

                                    {/* Route Multi-Select Dropdown */}
                                    <div className="dropdown" style={{ width: '200px' }}>
                                        <button 
                                            className="form-control text-start" 
                                            onClick={toggleRouteDropdown}
                                            style={{ textAlign: 'left' }}
                                        >
                                            {selectedRoutes.includes('all') ? 'All Routes' : `${selectedRoutes.length} Routes Selected`}
                                        </button>
                                        {isRouteDropdownOpen && (
                                            <div className="dropdown-menu show" style={{ minWidth: '250px', padding: '8px', overflowY: 'auto', maxHeight: '70vh' }}>
                                                <div className="mb-2 d-flex justify-content-between align-items-center border-bottom pb-2">
                                                    <strong>Select Routes</strong>
                                                    <button className="btn btn-sm btn-light" onClick={toggleRouteDropdown}>
                                                        ×
                                                    </button>
                                                </div>

                                                <div className="dropdown-item py-1">
                                                    <div className="form-check d-flex align-items-center">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            style={{ opacity: 0, position: 'absolute', left: '10px'}}
                                                            id="allRoutesCheckbox"
                                                            value="all"
                                                            checked={selectedRoutes.includes('all')}
                                                            onChange={() => handleRouteSelection('all')}
                                                        />
                                                        <label 
                                                            className="form-check-label ms-3" 
                                                            htmlFor="allRoutesCheckbox"
                                                            style={{ paddingLeft: '24px' }}
                                                        >
                                                            All Routes
                                                        </label>
                                                    </div>
                                                </div>

                                                {uniqueRoutes.map((route) => (
                                                    <div key={route} className="dropdown-item py-1">
                                                        <div className="form-check d-flex align-items-center">
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                style={{ opacity: 0, position: 'absolute', left: '10px'}}
                                                                id={`routeCheckbox-${route}`}
                                                                value={route}
                                                                checked={isRouteSelected(route)}
                                                                onChange={() => handleRouteSelection(route)}
                                                            />
                                                            <label
                                                                className="form-check-label ms-3"
                                                                htmlFor={`routeCheckbox-${route}`}
                                                                style={{ paddingLeft: '24px' }}
                                                            >
                                                                {route}
                                                            </label>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>

                                    {/* Vehicle Number Filter */}
                                    <select 
                                        className="form-control" 
                                        value={selectedVnum} 
                                        onChange={handleVnumChange}
                                        style={{ width: '200px' }}
                                    >
                                        <option value="all">All Vehicles</option>
                                        {uniqueVnums.map((vnum, index) => (
                                            <option key={index} value={vnum}>{vnum}</option>
                                        ))}
                                    </select>

                                    {showActionButtons && (
                                        <div style={{ display: 'flex', gap: '10px' }}>
                                            <button 
                                                className="btn btn-success" 
                                                onClick={() => downloadCombinedPDF('whatsapp')}
                                            >
                                                <i className="fa fa-whatsapp"></i> Send Selected
                                            </button>
                                            <button 
                                                className="btn btn-primary" 
                                                onClick={() => downloadCombinedPDF('print')}
                                            >
                                                <i className="fa fa-print"></i> Print Selected
                                            </button>
                                            <button 
                                                className="btn btn-warning" 
                                                onClick={() => downloadCombinedPDF('download')}
                                            >
                                                <i className="fa fa-download"></i> Download Selected
                                            </button>
                                        </div>
                                    )}

                                    <div style={{ marginLeft: 'auto' }}>
                                        <div className="d-inline-block align-top bg-edited px-2 py-1 me-1 fs-10 border-radius-8">
                                            Edited
                                        </div>
                                    </div>

                                    <div style={{ marginLeft: 'auto' }}>
                                        <div className="d-inline-block align-top bg-whatsapp px-2 py-1 me-1 fs-10 border-radius-8">
                                            WhatsApp
                                        </div>
                                    </div>

                                    <div style={{ marginLeft: 'auto' }}>
                                        <div className="d-inline-block align-top bg-both px-2 py-1 me-1 fs-10 border-radius-8">
                                            Edited & WhatsApp
                                        </div>
                                    </div>

                                    <div style={{ marginLeft: 'auto' }}>
                                        <div className="d-inline-block align-top bg-danger px-2 py-1 me-1 fs-10 border-radius-8">
                                            Cancelled
                                        </div>
                                    </div>


                                </div>
                            </div>

                            <div className="box-body">
                                <div className="table-responsive" style={{width: '100%', height: 'calc(100vh - 280px)', overflow: 'auto', padding: '0 10px 10px 10px'}}>
                                    <table style={{whiteSpace: 'nowrap'}} className="table-sm table-bordered nowrap fs-10" id="printableArea" width='100%'>
                                        <thead>
                                            <tr className="text-dark text-center" style={{ position: 'sticky', top: 0, zIndex: 2, backgroundColor: '#f8f9fa' }}>
                                                <th width="30px" className='text-center'>
                                                    <input 
                                                        type="checkbox" 
                                                        onChange={handleSelectAllChange}
                                                        checked={selectedInvoices.length === filteredOrders.length && filteredOrders.length > 0}
                                                    />
                                                </th>
                                                <th width="2%">S.No</th>
                                                <th width="6%">Date</th>
                                                <th>Dealer</th>
                                                <th>GSTIN</th>
                                                <th>E-INV</th>
                                                <th>Invoice ID</th>
                                                <th>Crates</th>
                                                <th>QTY</th>
                                                <th>L/KGs</th>
                                                <th>Amount</th>
                                                <th>Route</th>
                                                <th>Place</th>
                                                <th>View More</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredOrders.length > 0 ? 
                                            <>
                                            {filteredOrders.map((order, index) => {

                                                const tCrates = order?.orderData?.reduce((sum, item) => parseFloat(sum) + parseFloat(item?.qty), 0);
                                                const tQty = order?.orderData?.reduce((sum, item) => parseFloat(sum) + parseFloat(item?.qty * item?.itemGrade), 0);
                                                const tLKg = order?.orderData?.reduce((sum, item) => parseFloat(sum) + parseFloat(item?.qty * item?.itemGrade) * (item?.itemWeight/1000), 0);
                                                const tAmount = parseFloat(Math.ceil(parseFloat(order.totalPayment) - parseFloat(order.discount)));
                                                
                                                totalCrates += tCrates;
                                                totalQty += tQty;
                                                totalLKg += tLKg;
                                                totalAmount += tAmount;

                                                return (
                                                <tr key={index} className={order?.deleted === 'yes' ? 'bg-danger':  ((order?.edited === 'yes' && order?.pdf?.length > 0) ? 'bg-both' : order?.edited === 'yes' ? 'bg-edited' : order?.pdf?.length > 0 ? 'bg-whatsapp' : '')}>
                                                    <td className="text-center">
                                                        <input 
                                                            type="checkbox" 
                                                            checked={selectedInvoices.includes(order.orderId)}
                                                            onChange={() => handleCheckboxChange(order.orderId)}
                                                        />
                                                    </td>
                                                    <td className="text-center">{index + first + 1}</td>
                                                    <td className="text-center">{formatViewDate(order.date)}</td>
                                                    <td>{order.dealerData.dealer}</td>
                                                    <td>{order.dealerData.gst}</td>
                                                    <td style={{ textAlign: 'center', backgroundColor: order?.eInvNo?.length > 0 ? '#8ddda0' : '#eb6974' }}>
                                                        {order?.eInvNo?.length > 0 ? 'Yes' : 'No'}
                                                    </td>
                                                    <td>TRC/{order?.invoiceId}/{getFiscalYearLabel(new Date(order?.date))}</td>
                                                    <td className="text-end">{Number(tCrates).toFixed(2)}</td>
                                                    <td className="text-end">{Number(tQty).toFixed(2)}</td>
                                                    <td className="text-end">{Number(tLKg).toFixed(2)}</td>
                                                    <td className="text-end">{Number(tAmount).toFixed(2)}</td>
                                                    <td>{order.dealerData.routes}</td>
                                                    <td>{order.dealerData.locations}</td>
                                                    <td className="text-center">
                                                        <a 
                                                            href={`/invoice-details?id=${order.orderId}`} 
                                                            className="btn btn-sm btn-light" 
                                                            style={{textAlign: 'center'}}
                                                        >
                                                            View
                                                        </a>
                                                    </td>
                                                </tr>
                                                )})}
                                                
                                                <tr>
                                                    <th colSpan={7} className="text-start">Total</th>
                                                    <th className="text-end">{Number(totalCrates).toFixed(2)}</th>
                                                    <th className="text-end">{Number(totalQty).toFixed(2)}</th>
                                                    <th className="text-end">{Number(totalLKg).toFixed(2)}</th>
                                                    <th className="text-end">{Number(totalAmount).toFixed(2)}</th>
                                                </tr>
                                            </>
                                         : (
                                            <tr>
                                                <td className='text-center p-4' colSpan={11}>No Orders Found</td>
                                            </tr>
                                            )}
                                        </tbody>    
                                    </table>
                                </div>              
                            </div>
                        </div>
                    </section>
                </div>

                {/* Phone Number Dialog */}
                <div className="overlay" style={{ display: showPhoneDialog ? 'flex' : 'none', overflowY: 'scroll' }}>
                  <div className="popup" style={{ position: 'relative', padding: '50px', width: '100%', maxWidth: '700px', maxHeight: '90vh', overflowY: 'scroll' }}>
                    <button 
                      className="btn btn-danger" 
                      style={{ position: 'absolute', top: '15px', right: '15px' }} 
                      onClick={() => setShowPhoneDialog(false)}
                    >
                      <i className="fa fa-close"></i>
                    </button>
    
                    <h4 className="text-bold mb-4">Enter Missing Phone Numbers</h4>
    
                    <div className="container-fluid">
                      {dealersWithoutPhone.map((dealer, index) => (
                        <div className="row mt-3 text-start" key={index}>
                          <div className="col-lg-12">
                            <label>{dealer.dealerName} (Order #{dealer.orderId})</label>
                            <input
                              type="tel"
                              className={`form-control mt-2 ${phoneNumbers[dealer.orderId] && phoneNumbers[dealer.orderId].replace(/\D/g, '').length < 10 ? 'is-invalid' : ''}`}
                              value={phoneNumbers[dealer.orderId] || ''}
                              onChange={(e) => handlePhoneNumberChange(dealer.orderId, e.target.value)}
                              placeholder="Enter 10-digit phone number"
                            />
                            {phoneNumbers[dealer.orderId] && 
                             phoneNumbers[dealer.orderId].replace(/\D/g, '').length < 10 && (
                              <div className="invalid-feedback">
                                Please enter a valid 10-digit phone number
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
    
                    <div className="row mt-4">
                      <div className="col-lg-12 text-center">
                        <button 
                          className="btn btn-secondary me-3"
                          onClick={() => setShowPhoneDialog(false)}
                        >
                          Cancel
                        </button>
                        <button 
                          className="btn btn-primary"
                          onClick={sendAllInvoices}
                          disabled={dealersWithoutPhone.some(
                            dealer => !phoneNumbers[dealer.orderId] || 
                            phoneNumbers[dealer.orderId].replace(/\D/g, '').length < 10
                          )}
                        >
                          <i className="fa fa-paper-plane me-2"></i> Send All
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
            </div>

            {/* <Footer /> */}
        </>
    );
}

export default App;